var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"lottie-intro-ani-handler"},[_c('lottie',{ref:"introLottie",staticClass:"lottie-intro-ani-handler__lottie-wrapper",on:{"animCreated":_vm.handleAnimation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }